import { Action, createReducer, on } from '@ngrx/store';
import { IEmployeeParams, IPreviousSelfieResponse } from '../models/selfie.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { fromPrivacySettingsActions } from '../actions/';
import { IPrivacySettings } from '../models/privacy-settings.model';

export const privacySettingsFeatureKey = 'privacySettings';

export interface PrivacySettingsState {
  privacySettingsRequest: string | undefined;
  privacySettingsResponse: IPrivacySettings | undefined;
  privacySettingsFailure: IGenericError<ErrorResponse> | undefined;
  loaded: boolean | undefined;
}

export const initialState: PrivacySettingsState = {
  privacySettingsRequest: undefined,
  privacySettingsResponse: undefined,
  privacySettingsFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromPrivacySettingsActions.loadPrivacySettings, (state, action) => ({
    ...state,
    privacySettingsRequest: action.request
  })),
  on(fromPrivacySettingsActions.loadPrivacySettingssSuccess, (state, action) => ({
    ...state,
    privacySettingsResponse: action.response,
    loaded: true
  })),
  on(fromPrivacySettingsActions.loadPrivacySettingssFailure, (state, action) => ({
    ...state,
    privacySettingsFailure: action.error
  }))
);

export const getPrivacySettingsRequest = (state: PrivacySettingsState) => state.privacySettingsRequest;
export const getPrivacySettingsResponse = (state: PrivacySettingsState) => {
  return state.privacySettingsResponse;
};
export const getPrivacySettingsFailure = (state: PrivacySettingsState) => state.privacySettingsFailure;

export const getPrivacySettingsIsLoaded = (state: PrivacySettingsState) => state.loaded;
